import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { fetchSelfAssessment } from './actions';
import { withTranslation } from 'react-i18next';
import Components from '../assessmentForms/Components';
import SelfAssessmentForm from '../assessmentForms/Form';
import BackButton from '../../common/components/BackButton';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

class FormDetails extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.fetchSelfAssessment(Number(this.props.match.params.id));
	}
	
	render() {
		const { form, isReadonly, currentFormValues, t } = this.props;
		const { component } = form ? Components(form, currentFormValues) : {
			component: null, requiredFields: [], validationFunc: null
		};

		let values = form && form.content;

		if (values) {
			values.notes = form && form.notes;
		}

		let formName = form && form.form && form.form.name;
		return <div>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			{form && <SelfAssessmentForm
				title={formName && t(`AssessmentForm_SelfAssessment_${formName}`)}
				formComponent={component}
				initialValues={values}
				isReadonly={isReadonly} 
				allowSaveNotes={false}
				allowNotes={false}
			/>}
			<ToastContainer theme='colored' />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		entities: { selfAssessments }
	} = state;

	const form = selfAssessments[ownProps.match.params.id];

	return {
		form,
		isReadonly: true,
		currentFormValues: getFormValues('customForm')(state)
	};
};

export default connect(mapStateToProps, {
	fetchSelfAssessment,
})(withTranslation()(FormDetails));
